import { isDefined } from "@/utils/utils";
import { SplitCommission, SplitCommissionBatch } from "../splitcommissions/types";
import { CommissionKind, CommissionKindCategory, CommissionsBatchType } from "./enums";
import {
  CalculatedCommission,
  Commission,
  CommissionsBatch,
  CommissionsOutput,
  UpdateCommissionsBatchFinishedDate,
} from "./types";

export const removeBatchNameCustomSuffix = (batchName: string) => batchName.substring(0, 10);

export const isCommissionAdvanceBatch = (type: CommissionsBatchType | undefined, isTopAgentPlus: boolean): boolean =>
  isTopAgentPlus && type === CommissionsBatchType.PRIMARY;

const COMMISSION_KIND_INITIAL = [
  CommissionKind.INITIAL,
  CommissionKind.INITIAL_DIVIDED,
  CommissionKind.INDEXATION,
  CommissionKind.PREMIUM_CHANGE,
  CommissionKind.PREPAID_FEE,
  CommissionKind.PREPAID_EXPRESS_FEE,
  CommissionKind.ONGOING_FEE,
  CommissionKind.GRADUAL_PAYMENT,
  CommissionKind.GRADUAL_ADVANCE_PAYMENT,
  CommissionKind.SAVINGS,
  CommissionKind.PURCHASE,
  CommissionKind.VCN,
  CommissionKind.INITIAL_ELECTRONIC,
  CommissionKind.INITIAL_PAPER,
  CommissionKind.CONTRIBUTION_INCREASE,
  CommissionKind.SECOND_CONTRACT,
  CommissionKind.TRANSFERRED_FUNDS,
  CommissionKind.UNKNOWN,
];

export const getCommissionKindCategory = (commissionKind: CommissionKind) => {
  if (COMMISSION_KIND_INITIAL.includes(commissionKind)) {
    return CommissionKindCategory.INITIAL;
  } else if (commissionKind === CommissionKind.RENEWAL) {
    return CommissionKindCategory.RENEWAL;
  } else if (commissionKind === CommissionKind.BONUS || commissionKind === CommissionKind.BONUS_EXTENDED) {
    return CommissionKindCategory.BONUS;
  } else {
    return CommissionKindCategory.SUBSEQUENT;
  }
};

export const convertCommissionsBatchToCommissionsBatchFinishedDate = (
  batch: CommissionsBatch,
): UpdateCommissionsBatchFinishedDate => {
  return { optimisticLockVersion: batch.optimisticLockVersion, finishedDate: batch.finishedAt ?? "" };
};

export const getCalculatedCommissionGroup = (commission: Commission | SplitCommissionBatch | SplitCommission) => {
  const topAgentId = commission.calculatedCommissions[0]?.gainer.id;
  const groups: CalculatedCommission[][] = [];

  commission.calculatedCommissions.forEach((calculatedCommission, index) => {
    if (calculatedCommission?.gainer.id === topAgentId) {
      const endIndex = commission.calculatedCommissions.findIndex((cc, j) => j > index && cc.gainer.id === topAgentId);

      groups.push(
        commission.calculatedCommissions.slice(
          index,
          endIndex > 0 ? endIndex : commission.calculatedCommissions.length,
        ),
      );
    }
  });

  return groups;
};

export const showPaidCommissionsPopover = (record: CommissionsOutput) =>
  isDefined(record.calculatedCommissionAmountWithoutVat) ||
  isDefined(record.calculatedCommissionAmountVat) ||
  isDefined(record.calculatedCommissionAmountWithNoVat);
